module.exports = __webpack_public_path__ + "static/steuerberatung-ruberto-c53736779d559c3e8a7e870d6912a4d2.png";